import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../../media-query';
import _ from 'underscore';

class Component extends BaseComponent {
    componentDidMount() {
        this.vip = document.location.href.match(/vip/);

        this.props.links.map(link => {
            this.props.trackEvent([
                'Daily Nav',
                `${this.props.logged_in ? 'LI' : 'LO'} Impression`,
                link.label,
            ]);
        });

        if (MQ.isMobile()) {
            document.querySelector('.daily-links-container').scrollLeft = 37;
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        if (nextProps.links != this.props.links) {
            return true;
        }

        return false;
    }

    render({ links }) {
        if (links) {
            return (
                <daily-links>
                    <div className='daily-links-container'>
                        {this.reorder(links).map(this.renderLink)}
                    </div>
                </daily-links>
            );
        }

        return (<daily-links />);
    }

    renderLink = (link) => {
        let ahref = link.href;

        if (typeof link.href == 'object') {
            if (this.vip) {
                ahref = `/vip${link.href.nonmobile}`;
            } else {
                ahref = MQ.isMobile() ? link.href.mobile : link.href.nonmobile;
            }
        } else if (this.vip) {
            ahref = `/vip${ahref}`;
        }

        return (
            <a
                href={ahref}
                onClick={() => this.trackClick(link.label)}
            >
                <img
                    src={link.img}
                    alt={link.label}
                />
                <span dangerouslySetInnerHTML={{__html: link.html}} />
            </a>
        );
    }

    reorder = (links) => {
        if (MQ.isMobile()) {
            let retLinks = [];
            let keys = ['number', 'horoscope', 'love', 'tarot', 'psychic', 'hexagram'];

            if (this.vip) {
                keys = ['number', 'transits', 'horoscope', 'love', 'tarot', 'hexagram', 'psychic'];
            }

            while (keys.length) {
                links.forEach(link => {
                    if (link.slug == keys[0]) {
                        retLinks.push(link);
                        keys.shift();
                    }
                });
            }

            return retLinks;
        }

        return links;
    }

    trackClick = (label) => {
        this.props.trackEvent([ 'Daily Nav', `${this.props.logged_in ? 'LI' : 'LO'} Click`, label ]);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    links: state['daily-links'],
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
